import clsx from 'clsx';
import type { ButtonHTMLAttributes, ReactNode } from 'react';
import type { LexiconTone } from '../lexicon/tags.js';

export interface PillProps extends Omit<ButtonHTMLAttributes<HTMLButtonElement>, 'type'> {
  readonly pressed?: boolean;
  readonly tone?: LexiconTone;
  readonly size?: 'md' | 'sm';
  readonly count?: number;
  readonly dot?: boolean;
  readonly children: ReactNode;
}

/** Filtro de camada e de topico. Preenchido quando activo, nunca so uma borda. */
export function Pill({
  pressed = false, tone = 'neutral', size = 'md', count, dot = false, children, className, ...rest
}: PillProps) {
  return (
    <button
      type="button"
      aria-pressed={pressed}
      className={clsx('et-pill', `et-pill--${tone}`, size === 'sm' && 'et-pill--sm', className)}
      {...rest}
    >
      {dot && <span className="et-pill__dot" aria-hidden="true" />}
      <span className="et-pill__label">{children}</span>
      {count !== undefined && (
        <span className="et-pill__count" aria-hidden="true">{count}</span>
      )}
    </button>
  );
}
